import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {ProfilePage} from '/constant/TestIDs';

export interface RankNameProps {
  name: string;
}

export const RankName = ({name}: RankNameProps) => (
  <View accessible={true} accessibilityLabel={name} accessibilityRole="header">
    <Text
      testID={ProfilePage.profileRankName}
      variant="small"
      emphasis="low"
      allowFontScaling
      maxFontSizeMultiplier={2}
      accessible={true}>
      {name}
    </Text>
  </View>
);

export default RankName;
